export const HTTP_ERROR_INFO = {
  504: {
    documentTitle: "504 エラー",
    message: "エラー - サービスは利用できません",
    title: "エラー - サービスは利用できません",
  },
  503: {
    documentTitle: "503 エラー",
    message: "エラー - ゲートウェイのタイムアウト",
    title: "エラー - サービスは利用できません",
  },
  500: {
    documentTitle: "500 エラー",
    message: "アクセスしようとしたページは表示できませんでした。",
    title: "Internal Server Error",
  },
  404: {
    documentTitle: "404 エラー",
    message: "お探しのページは存在しないか、移動した可能性があります。",
    title: "Page Not Found",
  },
  403: {
    documentTitle: "403 エラー",
    message: "このエラーは、表示するページへのアクセス許可がなかったことを意味します。",
    title: "Forbidden",
  },
  401: {
    documentTitle: "401 エラー",
    message: "エラー - アクセスは許可されていません",
    title: "エラー - サービスは利用できません",
  },
  400: {
    documentTitle: "Error 400",
    message: "Bad request",
    title: "エラー - サービスは利用できません",
  },
};

export const HTTP_ERROR_CODES = {
  GATEWAY_TIMEOUT: 504,
  SERVICE_UNAVAILABLE: 503,
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
};

export const ERROR_IMPORT_FILE_SIZE = "容量が5MB以下のファイルをアップロードしてください。"
